export default __webpack_public_path__ + "static/TIMELINE_6-20083e581da19aa9a6f46e9b8c39d851.png";